/**
 * Voting helper utilities
 *
 * Extracted from VotingHeader component for react-refresh compatibility.
 *
 * @module utils/votingHelpers
 */

/**
 * Get urgency color class based on time remaining
 *
 * - Green: > 24 hours remaining
 * - Yellow: 2-24 hours remaining
 * - Red: < 2 hours remaining
 */
export function getUrgencyColorClass(votingEndsAt: number, now: number = Date.now()): string {
  const hoursRemaining = (votingEndsAt - now) / (1000 * 60 * 60);

  if (hoursRemaining <= 0) {
    return 'text-muted-foreground'; // Ended
  }

  if (hoursRemaining < 2) {
    return 'text-red-600 dark:text-red-400'; // Urgent
  }

  if (hoursRemaining < 24) {
    return 'text-yellow-600 dark:text-yellow-400'; // Approaching
  }

  return 'text-green-600 dark:text-green-400'; // Plenty of time
}

/**
 * Format time remaining as human-readable string
 */
export function formatTimeRemaining(votingEndsAt: number, now: number = Date.now()): string {
  const remaining = votingEndsAt - now;

  if (remaining <= 0) {
    return 'Voting ended';
  }

  const days = Math.floor(remaining / (24 * 60 * 60 * 1000));
  const hours = Math.floor((remaining % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((remaining % (60 * 60 * 1000)) / (60 * 1000));

  if (days > 0) {
    return `${days}d ${hours}h remaining`;
  }

  if (hours > 0) {
    return `${hours}h ${minutes}m remaining`;
  }

  return `${minutes}m remaining`;
}
